import { render, staticRenderFns } from "./edit-gallery-settings.vue?vue&type=template&id=6318e5ce&scoped=true&"
import script from "./edit-gallery-settings.vue?vue&type=script&lang=ts&"
export * from "./edit-gallery-settings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6318e5ce",
  null
  
)

export default component.exports